export const mainCities = [
    {id: 1, name: "Москва"},
    {id: 2, name: "Санкт-Петербург"},
    {id: 3, name: 'Новосибирск'},
    {id: 4, name: "Краснодар"},
    {id: 5, name: "Екатеринбург"},
    {id: 6, name: "Казань"},
    {id: 7, name: "Уфа"},
    {id: 8, name: "Нижний Новгород"},
    {id: 9, name: "Челябинск"},
    {id: 10, name: "Самара"},
    {id: 11, name: "Саранск"},
    {id: 12, name: "Саратов"},
    {id: 13, name: "Сызрань"},
    {id: 14, name: "Ростов на Дону"},
    {id: 15, name: "Омск"},
    {id: 16, name: "Красноярск"},
    {id: 17, name: "Владивосток"},
];

export const regularCities = [
    { id: 2, name: "Анадырь", region: "" },
    { id: 3, name: "Анапа", region: "" },
    { id: 4, name: "Архангельск", region: "" },
    { id: 6, name: "Белгород", region: "" },
    { id: 7, name: "Благовещенск", region: "" },
    { id: 8, name: "Брянск", region: "" },
    { id: 9, name: "Великий Новгород", region: "" },
    { id: 10, name: "Видное", region: "" },
    { id: 12, name: "Горно-Алтайск", region: "" },
    { id: 13, name: "Грозный", region: "" },
    { id: 14, name: "Дзержинский", region: "" },
    { id: 15, name: "Долгопрудный", region: "" },
    { id: 16, name: "Дятьково", region: "" },
    { id: 17, name: "Екатеринбург", region: "" },
    { id: 18, name: "Заволжье", region: "" },
    { id: 19, name: "Западный", region: "" },
    { id: 20, name: "Засечное", region: "" },
    { id: 21, name: "Ивановка", region: "" },
    { id: 22, name: "Иваново", region: "" },
    { id: 23, name: "Ижевск", region: "" },
    { id: 25, name: "Казань", region: "" },
    { id: 26, name: "Калининград", region: "" },
    { id: 27, name: "Краснодар", region: "" },
    { id: 28, name: "Красноярск", region: "" },
    { id: 29, name: "Курск", region: "" },
    { id: 30, name: "Липецк", region: "" },
    { id: 31, name: "Люберцы", region: "" },
    { id: 33, name: "Магнитогорск", region: "" },
    { id: 34, name: "Москва", region: "" },
    { id: 35, name: "Набережные Челны", region: "" },
    { id: 36, name: "Нальчик", region: "" },
    { id: 37, name: "Нижний Новгород", region: "" },
    { id: 38, name: "Омск", region: "" },
    { id: 39, name: "Оренбург", region: "" },
    { id: 40, name: "Орёл", region: "" },
    { id: 41, name: "Пенза", region: "" },
    { id: 42, name: "Пермь", region: "" },
    { id: 43, name: "Петрозаводск", region: "" },
    { id: 44, name: "Петропавловск-Камчатский", region: "" },
    { id: 45, name: "Ростов-на-Дону", region: "" },
    { id: 46, name: "Рязань", region: "" },
    { id: 47, name: "Салехард", region: "" },
    { id: 48, name: "Самара", region: "" },
    { id: 49, name: "Санкт-Петербург", region: "" },
    { id: 50, name: "Саратов", region: "" },
    { id: 51, name: "Тамбов", region: "" },
    { id: 52, name: "Тверь", region: "" },
    { id: 53, name: "Томск", region: "" },
    { id: 54, name: "Улан-Удэ", region: "" },
    { id: 55, name: "Ульяновск", region: "" },
    { id: 56, name: "Уфа", region: "" },
    { id: 57, name: "Учалы", region: "" },
    { id: 58, name: "Фрязино", region: "" },
    { id: 59, name: "Фряново", region: "" },
    { id: 61, name: "Ханты-Мансийск", region: "" },
    { id: 62, name: "Чебоксары", region: "" },
    { id: 63, name: "Челябинск", region: "" },
    { id: 64, name: "Черкесск", region: "" },
    { id: 65, name: "Чехов", region: "" },
    { id: 66, name: "Чита", region: "" },
    { id: 67, name: "Шахты", region: "" },
    { id: 68, name: "Щёлково", region: "" },
    { id: 69, name: "Элиста", region: "" },
    { id: 70, name: "Энгельс", region: "" },
    { id: 72, name: "Юность", region: "" },
    { id: 73, name: "Якутск", region: "" },
    { id: 74, name: "Ярославль", region: "" },
];




















